import { IApplicationState } from '../../types/redux';

export const selectIsPopupOpen = (state: IApplicationState) => {
  return state.callbackPopup.isOpen;
};
